import { useContext } from 'react';

import { Box } from '@uptime/design-system/components/Box';
import { Divider } from '@uptime/design-system/components/Divider';
import { Sidebar as DesignSystemSidebar } from '@uptime/design-system/components/Sidebar';
import { ThemeProviderV7 } from '@uptime/design-system/MUIv7Exports';
import { DRAWER_WIDTH } from '@uptime/shared/constants';
import { UIContext } from '@uptime/shared/providers/UIProvider';

import SidebarHeader from './SidebarHeader';
import SidebarList from './SidebarList';

const Sidebar = () => {
  const { sidebarIsOpen, setSidebarIsOpen } = useContext(UIContext);
  const closeSidebar = () => setSidebarIsOpen(false);

  return (
    <ThemeProviderV7>
      <DesignSystemSidebar width={DRAWER_WIDTH} open={sidebarIsOpen} onSidebarClose={closeSidebar}>
        <SidebarHeader />
        <Divider />
        <Box sx={{ height: '100%', overflowY: 'auto' }}>
          <SidebarList onNavigate={closeSidebar} />
        </Box>
      </DesignSystemSidebar>
    </ThemeProviderV7>
  );
};

export default Sidebar;
